import { render, staticRenderFns } from "./ReferralNavigation.vue?vue&type=template&id=756c3d9f&scoped=true"
import script from "./ReferralNavigation.vue?vue&type=script&lang=js"
export * from "./ReferralNavigation.vue?vue&type=script&lang=js"
import style0 from "./ReferralNavigation.vue?vue&type=style&index=0&id=756c3d9f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c3d9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756c3d9f')) {
      api.createRecord('756c3d9f', component.options)
    } else {
      api.reload('756c3d9f', component.options)
    }
    module.hot.accept("./ReferralNavigation.vue?vue&type=template&id=756c3d9f&scoped=true", function () {
      api.rerender('756c3d9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/components/ReferralNavigation.vue"
export default component.exports